import { memo } from 'react';

import { Controller, useFormContext } from 'react-hook-form';
// components
import { CustomOutlinedInput } from 'components/inputs/custom-outlined-input';

interface OwnProps {
  name: string;
  label?: string;
  placeholder?: string;
  withError?: boolean;
  additionalOnChange?: (e: any) => void;
  [x: string]: any;
}

export const OutlinedInputController: React.FC<OwnProps> = memo(
  ({ name = '', defaultValue = '', withError, additionalOnChange, ...props }) => {
    const { control } = useFormContext();

    return (
      <Controller
        render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => {
          const handleChange = (e: any) => {
            if (!!additionalOnChange) {
              additionalOnChange(e);
            }

            if (!additionalOnChange) {
              onChange(e);
            }
          };

          return (
            <CustomOutlinedInput
              {...props}
              name={name}
              value={value}
              error={!!error}
              onBlur={onBlur}
              onChange={handleChange}
              helperText={withError ? error?.message || ' ' : ' '}
            />
          );
        }}
        name={name}
        control={control}
        defaultValue={defaultValue}
      />
    );
  }
);
